import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { passwordValidator, matchPasswordValidator } from 'src/app/_shared/validators/validators';
import { UserService } from 'src/app/_shared/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { BaseResponse } from '../_shared/models/base-response.model';
import { Jwt } from '../_shared/models/jwt.model';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-set',
  templateUrl: './set.component.html',
  styleUrls: ['./set.component.scss']
})
export class SetComponent implements OnInit {

  private token: string | null = null;
  public form: FormGroup;
  public isLoading: boolean = false;

  constructor(private _route: ActivatedRoute, private _fb: FormBuilder, private _userService: UserService,
    private _router: Router, private _toastr: ToastrService) {
    // token
    this._route.queryParams.subscribe((params) => {
      this.token = params["token"];
    }, (error) => console.log(error));
    // form
    this.form = this._fb.group({
      'passwords': this._fb.group({
        'password': [null, Validators.compose([Validators.required, passwordValidator])],
        'confirmpassword': [null, Validators.compose([Validators.required])]
      }, {validator: matchPasswordValidator})
    });
  }

  ngOnInit(): void {
  }

  public submit(form: any) {
    this.isLoading = true;
    this._userService.signinByClientCredentials().subscribe((response: Jwt) => {
      this._userService.setPassword(response.access_token, form.passwords.password.trim(), this.token).subscribe((response: BaseResponse<{first_name: string, username: string}>) => {
        this.isLoading = false;
        const name = response?.data?.first_name;
        this._toastr.success(`Dear ${name ? name?.toLocaleLowerCase() : 'user'} you have successfully set your password`, "Success");
        this._router.navigate(['/signin']);
      }, (error:HttpErrorResponse) => {
        this.isLoading = false;
        const status = error.status;
        if(status != 0 && status != 401 && status != 500) {
          this._toastr.error(error?.error?.api_code_description, 'Failed');
        }
      });
    }, () => this.isLoading = false);
  }

  public isTouched(groupName: string, inputName: string): boolean | undefined{
    return this.form.controls[groupName].get(inputName)?.touched;
  }
  public isInValid(groupName: string, inputName: string, error: string): boolean | undefined{
    return this.form.controls[groupName].get(inputName)?.hasError(error);
  }
  public get isPasswordMatchInvalid() {
    return this.form.controls['passwords'].hasError('invalid') && this.isTouched('passwords', 'password') && this.isTouched('passwords', 'confirmpassword');
  }
  public get isPasswordInvalid() {
    return this.isInValid('passwords', 'password', 'required') && this.isTouched('passwords', 'password');
  }
  public get isPasswordStrengthInvalid() {
    return this.isInValid('passwords', 'password', 'isNotStrong') && !this.isInValid('passwords', 'password', 'required') && this.isTouched('passwords', 'password');
  }
  public get isConfirmPasswordInvalid() {
    return this.isInValid('passwords', 'confirmpassword', 'required') && this.isTouched('passwords', 'confirmpassword');
  }
}
